module.exports = __webpack_public_path__ + "static/media/Agri Contract Manufacturers Infographic desktop - GBR Tech - 24-05-2024 C.4e16e33a.gif";